import { css, cx } from '@emotion/css';
import { IgnorePageMarginsStyle } from 'Shared/frontend/IgnorePageMarginsStyle';
import { SubNav } from 'Shared/frontend/SubNav';
import { theme } from 'Shared/frontend/SettingsProvider';
import { Switch, Match, For } from 'solid-js';


const stickyStyle = () => css({
	position: 'sticky',
	top: '0',
	zIndex: '10',

	/* NOTE equal to SubNav innerStyle() margins. Unfortunately we either have collapsing margins OR stickiness it seems. */
	marginTop: '-32px', 
	marginBottom: '-32px', 
});

//TODO hover
//const stickyNavButtonStyle = () => css(theme().widgets.subNav.button);

const buttonStyle = (isNav:boolean) => css(isNav ? theme().widgets.subNav.button : theme().button);

const plainStyle = () => css({
	marginTop: '2em',
	marginBottom: '2em'
});


export function Buttons(P)
{
	let stickyNode!: HTMLElement;

	//NOTE with sticky the section loses its vertical margins. The SubNav provides its own.

	return (
		<Switch>
			<Match when={P.isNav}>
				<div ref={stickyNode} class={css(P.sticky && stickyStyle(), P.sticky.css)}>
					<IgnorePageMarginsStyle disable={!P.sticky}>
						<SubNav>
							<ButtonList {...P} />
						</SubNav>
					</IgnorePageMarginsStyle>
				</div>
			</Match>
			<Match when={true}>
				<div class={css(plainStyle(), P.styling?.css)}>
					<ButtonList {...P} />
				</div>
			</Match>
		</Switch>
	);
}

function ButtonList(P)
{
	const handleClick = item => {
		if (item.openInSameWindow) { 	//TODO improve name
			//TODO share with jumpToAnchor()
			document.location = item.link;
 			window.scrollBy(0,-100);
		}
		else
			window.open(item.link, '_blank')?.focus();
	}

//TODO move the gDriveDownloadAsPDF stuff into handleClick()	
	return (
		<For each={P.buttons}>{item =>
			<Switch>
				{/* Sanity check if google doc url doesn't contain /edit?usp=sharing we can't convert it to a PDF */}
				<Match when={
					item.gDriveDownloadAsPDF &&
					item.link?.includes('google.com/document/') && 
					item.link?.includes('/edit?usp=sharing') 
				}>
					<a href={item.link.replace('/edit?usp=sharing','/export?format=pdf')} target='_blank'>
						<button class={buttonStyle(P.isNav)}>
							{item.text ?? 'Button'}
						</button>
					</a>
				</Match>
				<Match when={true}>
					<button class={buttonStyle(P.isNav)} onClick={() => handleClick(item)}>
						{item.text ?? 'Button'}
					</button>
				</Match>
			</Switch>
		}</For>
	);
}

